import { SkeletonPlaceholder, Tile } from '@carbon/react';
import cx from 'clsx';

import styles from 'theme/features/dashboard/components/breakdown-section.module.scss';

const BreakdownSection = ({ title, type, isLoading, children }) => (
  <article>
    <Tile className={cx(styles.header, styles[type])}>
      <p>
        <strong>{title}</strong>
      </p>
    </Tile>
    {isLoading ? <SkeletonPlaceholder className={styles['content-skeleton']} /> : children}
  </article>
);

export default BreakdownSection;
